import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

import { CartStore } from 'app/store/cart.store'
import { UserStore } from 'app/store/user.store'

@Injectable({
  providedIn: 'root'
})
export class KitGuard implements CanActivate {
  userStore = inject(UserStore)
  cartStore = inject(CartStore)

  constructor(private router: Router) {}

  canActivate(): boolean {
    if (this.cartStore.giftingToken()) {
      this.router.navigate(['/'])
      return false
    }
    return true
  }
}
